export default __webpack_public_path__ + "static/dunsworth-926de6f8df397bcac24e142da40415ac.jpg";